import React, { useEffect, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import BillingOverview from './Tabs/billingOverview/BillingOverview';
import BillingPaymentMethod from './Tabs/billingPaymentMethod/BillingPaymentMethod';
import BillingHistory from './Tabs/billingHistory/BillingHistory';
import BillingCreditGrants from './Tabs/billingCreditGrants/BillingCreditGrants';
import BillingTransactionHistory from './Tabs/billingTransactionHistory/BillingTransactionHistory';
import './billingUsage.scss';
import { callApiWithoutDispatch } from '../../utils/apiUtils';
import {
  onBoardingBillingDetailApi,
  onBoardingGetFleetBillingUrlApi,
} from '../../constants/ApiConfigs';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import BillingSubscription from './Tabs/billingSubscription';
import './Tabs/billingOverview/billingOverview.scss';
import { bindActionCreators } from 'redux';
import * as loadingActions from '../../actions/loadingBarActions';
import { I18n } from 'react-redux-i18n';
import { FLEET_BILLING_MODE, OPEN_BILLING_TOPUP_MODAL_EVENT } from './utils/constants';
export const TAB_LIST = {
  overview: 'overview',
  paymentMethods: 'paymentMethods',
  billingHistory: 'billingHistory',
  creditGrants: 'creditGrants',
  transactionHistory: 'transactionHistory',
  subscription: 'subscription',
};

const BillingUsage = ({ auth, params, permissions, ...props }) => {
  const [tabSelected, setTabSelected] = useState(
    params?.tabActive || TAB_LIST.overview
  );
  const [isShowTopupPopup, setIsShowTopupPopup] = useState(false);
  const [billingUsage, setBillingUsage] = useState(null);
  useEffect(() => {
    handleLoadBillingUsage();
  }, []);

  useEffect(() => {
    if (props?.location?.query?.action === 'force-topup-make-payment') {
      setIsShowTopupPopup(true);
    }
  }, [props?.location?.query?.action, props?.location?.search]);

  useEffect(() => {
    const openModal = () => setIsShowTopupPopup(true);
    window.addEventListener(OPEN_BILLING_TOPUP_MODAL_EVENT, openModal);
    return () =>
      window.removeEventListener(OPEN_BILLING_TOPUP_MODAL_EVENT, openModal);
  }, []);

  const handleLoadBillingUsage = async () => {
    try {
      props.loadingActions.showLoadingSpiner();
      const response = await callApiWithoutDispatch(
        onBoardingBillingDetailApi,
        {
          method: 'POST',
          body: JSON.stringify({
            fleetId: auth?.selectedFleet?.fleetId,
          }),
        }
      );
      if (response?.res?.data) {
        setBillingUsage(response.res.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      props.loadingActions.hideLoadingSpiner();
    }
  };

  const openBillingUrl = async () => {
    try {
      props.loadingActions.showLoadingSpiner();
      const response = await callApiWithoutDispatch(
        onBoardingGetFleetBillingUrlApi,
        {
          method: 'GET',
          params: {
            fleetId: auth?.selectedFleet?.fleetId,
            returnUrl: window.location.href,
          },
        }
      );
      if (response?.res?.url) {
        window.location.href = response?.res?.url;
      }
    } catch (error) {
      I18n.t('billingUsage.failedToOpenBillingUrl');
    } finally {
      props.loadingActions.hideLoadingSpiner();
    }
  };

  const handleTabSelect = (key) => {
    // navigate(`/settings/Billing_usage/${key}`);
    if (key === TAB_LIST.paymentMethods) {
      openBillingUrl();
    } else {
      props.router.push(`/settings/Billing_usage/${key}`);
      setTabSelected(key);
    }
  };

  return (
    <div id={'billingUsageContainer'}>
      <h1>{I18n.t('billingUsage.billingAndUsage')}</h1>
      <div className="billingUsageTabs">
        <Tabs
          id="billingUsageTabs"
          defaultActiveKey={params?.tabActive || TAB_LIST.overview}
          onSelect={handleTabSelect}
          activeKey={tabSelected}
        >
          <Tab eventKey={TAB_LIST.overview} title={I18n.t('billingUsage.overview')}>
            <BillingOverview
              billingUsage={billingUsage}
              onLoadBillingUsage={handleLoadBillingUsage}
              onTabSelect={handleTabSelect}
              auth={auth}
              router={props.router}
              permissions={permissions}
              setIsShowTopupPopup={setIsShowTopupPopup}
              isShowTopupPopup={isShowTopupPopup}
              onOpenBillingUrl={() => openBillingUrl()}
            />
          </Tab>
          {
            permissions.actions &&
            billingUsage?.billingMode !== FLEET_BILLING_MODE.invoice && (
              <Tab eventKey={TAB_LIST.paymentMethods} title={I18n.t('billingUsage.managePayment')}>
                <BillingPaymentMethod auth={auth} billingUsage={billingUsage} />
              </Tab>
            )
          }
          <Tab eventKey={TAB_LIST.creditGrants} title={I18n.t('billingUsage.creditGrants')}>
            <BillingCreditGrants auth={auth} billingUsage={billingUsage} />
          </Tab>
          <Tab
            eventKey={TAB_LIST.transactionHistory}
            title={I18n.t('billingUsage.transactionHistory')}
          >
            <BillingTransactionHistory
              auth={auth}
              loadingActions={props.loadingActions}
              notification={props.notification}
              billingUsage={billingUsage}
              tabActive={tabSelected}
            />
          </Tab>
          {
            billingUsage?.billingMode !== FLEET_BILLING_MODE.invoice && (
              <Tab eventKey={TAB_LIST.subscription} title={I18n.t('billingUsage.manageSubscription')}>
                {billingUsage && (
                  <BillingSubscription
                    billingUsage={billingUsage}
                    permissions={permissions}
                    handleLoadBillingUsage={handleLoadBillingUsage}
                  />
                )}
              </Tab>
            )
          }
        </Tabs>
      </div>
    </div>
  );
};

BillingUsage.contextTypes = {
  notification: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    auth: state.auth,
    permissions: state.menuHandle.modulePermission,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadingActions: bindActionCreators(loadingActions, dispatch),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(BillingUsage);
